export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAAAAAA6mKC9AAAAGElEQVR42mP4DwVnoIBhgARgDJjEAAkAAPQn5YHz5y7mAAAAAElFTkSuQmCC"